import VisaLogo from './cards/visa.webp';
import MastercardLogo from './cards/mastercard.webp';
import MeezaLogo from './cards/meeza.webp';

export const CardProvider = {
  VISA: 'VISA',
  MASTERCARD: 'MASTERCARD',
  MEEZA: 'MEEZA',
};
export const CardProvidersLogos = {
  [CardProvider.VISA]: VisaLogo,
  [CardProvider.MASTERCARD]: MastercardLogo,
  [CardProvider.MEEZA]: MeezaLogo,
};
